// STED (MGRS) og TID (datetime-local) — RENE hjelpere for skjemaene som fører
// rom/tid på etterretningsprodukter og RFI-er (UX-funn 8).
//
// HVORFOR egen fil: apps/cop har ingen jsdom i workspacet, så all logikk som
// skal testes MÅ ligge utenfor DOM-klassene (samme grep som report-composer.ts
// og lysforhold.ts). Panelene leser bare svarene herfra.
import { mgrsToLatLon, type LatLon } from '@skade/contracts';

export interface StedSvar {
  /** Kompakt MGRS (wire-form, som `latLonToMgrs` gir — formatér ved visning). */
  mgrs: string;
  lat: number;
  lon: number;
}

/**
 * Tolk et manuelt MGRS-felt. Normaliserer (mellomrom bort, store bokstaver) og
 * validerer ved å faktisk regne strengen om til lat/lon — en regex kan godta
 * en referanse som ikke finnes på jorda, og et sted som ikke kan plottes er
 * ikke et sted. Tom streng og ugyldig streng er TO ULIKE svar: tom betyr
 * «ikke oppgitt», null betyr «oppgitt men galt» — bare det siste skal blokkere.
 */
export function tolkMgrsFelt(raw: string): StedSvar | null | 'tom' {
  const s = raw.replace(/\s+/g, '').toUpperCase();
  if (!s) return 'tom';
  const p: LatLon | null = mgrsToLatLon(s);
  if (!p) return null;
  return { mgrs: s, lat: p.lat, lon: p.lon };
}

/**
 * ms epoch → verdi for `<input type="datetime-local">` (LOKAL tid, uten sone).
 * Minutt-presisjon: det er hva feltet viser, og et gyldighetsvindu for et
 * etterretningsprodukt trenger ikke sekunder.
 */
export function msTilDatetimeLocal(ms?: number): string {
  if (ms === undefined || !Number.isFinite(ms)) return '';
  const d = new Date(ms);
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}

/** `datetime-local`-verdi → ms epoch. Tom/utolkelig gir undefined («ikke satt»),
 * aldri NaN — en NaN i kontrakten ville feilet zod-valideringen ved deling. */
export function datetimeLocalTilMs(v: string): number | undefined {
  const t = v.trim();
  if (!t) return undefined;
  const ms = new Date(t).getTime();
  return Number.isFinite(ms) ? ms : undefined;
}
